import anime from 'animejs';
import BaseComponent from 'foundation/base-component';
import Scroller from '../../../general/js/scroller';
import * as cookieHelper from '../../sso/helpers/cookie-helper';

export default class Hero extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.state = {
            isOneClubMember: this.getOneClubMemberValueFromCookie()
        };

        this.sticky = this.refs.sticky;
        this.stickyIsShown = false;
        this.observerIsCreated = false;
        this.promptScroller = null;

        this.onResize = this.onResize.bind(this);
        this.onClickPrompt = this.onClickPrompt.bind(this);

        this.onResize();
        this.init();
}

    init() {
        this.disableButtonsWhenUserIsOneClubMember();
        this.checkViewportWidth();
        this.addBottomPadding();

        this.addListener(window, 'resize', this.onResize);

        if (this.refs.prompt) {
            this.initScroller();
        }
    }

    getOneClubMemberValueFromCookie() {
        const cookie = cookieHelper.getCookie('userData');
        const parsedCookie = JSON.parse(cookie);

        if (parsedCookie != null) {
            return parsedCookie.isOneClubMember;
        }

        return false;
    }

    disableButtonsWhenUserIsOneClubMember() {
        if (this.state.isOneClubMember && this.options.disableCta1 === 'true') {
            this.refs.cta1.classList.add('hidden');
            this.refs.cta1sticky.classList.add('hidden');
        }

        if (this.state.isOneClubMember && this.options.disableCta2 === 'true') {
            this.refs.cta2.classList.add('hidden');
            this.refs.cta2sticky.classList.add('hidden');
        }
    }

    checkViewportWidth() {
        this.viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    onResize() {
        this.checkViewportWidth();

        if (this.viewportWidth > 767 && !this.observerIsCreated) {
            this.removeBottomPadding();
            this.createObserver();
        } else if (this.viewportWidth < 768 && this.observerIsCreated) {
            this.addBottomPadding();
            this.observer.disconnect();
            this.sticky.classList.remove('is-shown');
            this.observerIsCreated = false;
        }
    }

    createObserver() {
        this.observer = new IntersectionObserver((changes) => {
            const change = changes[0];
            if (change.intersectionRatio > 0) {
                this.hideSticky();
            } else if (!this.state.isOneClubMember) {
                this.showSticky();
            } else if (this.options.disableStickyHeader === 'false') {
                this.showSticky();
            }
        });
        this.observer.observe(this.element);
        this.observerIsCreated = true;
    }

    showSticky() {
        this.stickyIsShown = true;
        this.sticky.classList.add('is-shown');

        anime({
            targets: this.sticky,
            translateY: [-100, 0],
            duration: 500,
            easing: 'linear'
        });
    }

    hideSticky() {
        if (this.stickyIsShown) {
            this.stickyIsShown = false;
            anime({
                targets: this.sticky,
                translateY: [0, -100],
                duration: 300,
                easing: 'linear',
                complete: () => {
                    this.sticky.classList.remove('is-shown');
                }
            });
        }
    }

    initScroller() {
        const elementId = this.refs.prompt.getAttribute('href');
        const blockToShow = document.querySelector(elementId);

        if (blockToShow) {
            this.promptScroller = new Scroller(blockToShow);
            this.addListener(this.refs.prompt, 'click', this.onClickPrompt);
        }
    }

    onClickPrompt(event) {
        event.preventDefault();
        this.promptScroller.scrollToTop();
    }

    addBottomPadding() {
        this.blankElement = document.createElement('div');
        this.blankElement.style.height = `${this.sticky.clientHeight}px`;
        document.body.appendChild(this.blankElement);
    }

    removeBottomPadding() {
        if (this.blankElement) {
            document.body.removeChild(this.blankElement);
        }
    }
}
